<template>
  <div class="take_to">
    <div class="bg">
      <span class="tips">请填写带访人及推荐人信息</span>
    </div>
    <div class="main">
      <div class="table">
        <van-form
          @submit="onSubmit"
          input-align="right"
          error-message-align="right"
        >
          <div class="old_info">
            <div class="head"><span></span><span>老业主信息</span></div>
            <div class="must">
              <!-- 姓名 -->
              <van-field
                v-model="oldName"
                name="userName"
                :border="false"
                label="客户姓名"
                placeholder="请输入签约客户姓名"
                :required="true"
                :rules="[
                  { validator: userName, message: '姓名长度在2-10个汉字之间' },
                  {
                    pattern: /^[\u4e00-\u9fa50-9A-Za-z]*$/,
                    message: '姓名格式错误！',
                  },
                ]"
              />
              <div class="line"></div>
              <!-- 身份证 -->
              <van-field
                v-model="idCard"
                name="idCard"
                :border="false"
                label="身份证"
                placeholder="请输入签约身份证号码"
                :required="true"
                :rules="[
                  { required: true, message: '请输入身份证' },
                  {
                    pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
                    message: '身份证号码格式错误！',
                  },
                ]"
              />
              <div class="line"></div>
              <!-- 电话号码 -->
              <van-field
                v-model="oldPhone"
                :required="true"
                type="number"
                name="mobile"
                :border="false"
                label="电话"
                placeholder="请输入签约电话号码"
                :rules="[
                  { required: true, message: '请输入签约电话号码' },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '电话号码格式错误！',
                  },
                ]"
              />
              <div class="line"></div>
            </div>
          </div>

          <div class="old_info">
            <div class="head"><span></span><span>推荐人信息</span></div>

            <div class="must">
              <!-- 姓名 -->
              <van-field
                :required="true"
                v-model="presentee"
                name="userName"
                :border="false"
                label="客户姓名"
                placeholder="请输入客户姓名"
                :rules="[
                  { validator: userName, message: '姓名长度在2-10个汉字之间' },
                ]"
              />
              <div class="line"></div>
              <!-- 性别 -->
              <van-field
                :required="true"
                name="gender"
                label="性别"
                :border="false"
                :rules="[
                  {
                    required: true,
                    message: '请选择性别',
                    trigger: 'onChange',
                  },
                ]"
              >
                <template #input>
                  <van-radio-group v-model="gender" direction="horizontal">
                    <van-radio name="0" icon-size="14px">
                      <img
                        class="sex_icon"
                        :src="
                          gender == '0' ? nan_select_icon : nan_unselect_icon
                        "
                        alt
                      />
                      <template #icon="props">
                        <img
                          class="img-icon"
                          :src="props.checked ? activeIcon : inactiveIcon"
                        />
                      </template>
                    </van-radio>
                    <van-radio name="1" icon-size="14px">
                      <img
                        class="sex_icon"
                        :src="gender == '1' ? nv_select_icon : nv_unselect_icon"
                        alt
                      />
                      <template #icon="props">
                        <img
                          class="img-icon"
                          :src="props.checked ? activeNvIcon : inactiveIcon"
                        />
                      </template>
                    </van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <div class="line"></div>
              <!-- 电话号码 -->
              <van-field
                :required="true"
                v-model="contactNumber"
                type="number"
                name="mobile"
                :border="false"
                label="电话"
                placeholder="请输入手机号码"
                :rules="[
                  { required: true, message: '请输入电话号码' },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '电话号码格式错误！',
                  },
                ]"
              />
              <div class="line"></div>
              <!-- 城市公司 -->
              <van-field v-model="orgName" label="推荐城市" disabled />

              <!-- 推荐项目 -->
              <van-field v-model="projectName" label="推荐项目" disabled />

              <!-- 置业顾问 -->
              <van-field v-model="adviserName" label="置业顾问" disabled />
            </div>
          </div>
          <div class="no-must">
            <!-- 备注 -->
            <van-cell v-model="remark" :border="false">
              <template #default>
                <van-field
                  v-model="remark"
                  type="textarea"
                  label="备注"
                  maxlength="120"
                  show-word-limit
                  name="message"
                  placeholder="还想说点什么"
                  input-align="left"
                />
              </template>
            </van-cell>
          </div>
          <div></div>
          <div class="btn">
            <van-button round block type="info" native-type="submit"
              >确认推荐</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <!-- 推荐成功弹框 -->
    <van-popup
      v-model="showSuccess"
      round
      style="border-radius: 10px;"
      :close-on-click-overlay="false"
    >
      <div class="tip_success">
        <div class="icon">
          <img
            class="success_icon"
            :src="
              isSuccess
                ? require('../../common/images/recommend/recommend_success.png')
                : require('../../common/images/recommend/recommend_failed.png')
            "
          />

          <div class="status">{{ isSuccess ? "推荐成功" : "推荐失败" }}</div>
          <p>{{ tipsContent }}</p>
        </div>
        <div class="success_btn" @click="back">我知道了</div>
      </div>
    </van-popup>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";
import { Form, RadioGroup, Radio, Field, Popup, Toast } from "vant";
import vanPopupSelect from "@/components/vanPopupSelect";
export default {
  components: {
    "van-form": Form,
    "van-radio": Radio,
    "van-radio-group": RadioGroup,
    "van-field": Field,
    "van-popup-select": vanPopupSelect,
    "van-popup": Popup,
    loading,
  },
  data() {
    return {
      loadingStatus: false,
      flag: true, // 防止重复点击
      showErrTips: false,
      timer: null, // 定时器参数
      timerFlag: null,
      activeIcon: require("../../common/images/recommend/gender_select.png"),
      inactiveIcon: require("../../common/images/recommend/gender_unselect.png"),
      activeNvIcon: require("../../common/images/recommend/gender_nv_select.png"),
      nan_select_icon: require("../../common/images/recommend/sex_nan_select.png"),
      nan_unselect_icon: require("../../common/images/recommend/sex_nan_unselect.png"),
      nv_select_icon: require("../../common/images/recommend/sex_nv_select.png"),
      nv_unselect_icon: require("../../common/images/recommend/sex_nv_unselect.png"),
      props: { checked: null },
      cityList: [
        // {orgName: '成都', orgCode: 'SDASJD-789ASDA7S'}
      ],
      projList: [
        // {projectName: '大连普食素', projectCode: 'SDA9SDA87SDA-ASDA8'}
      ],
      adviserList: [], // 置业顾问列表
      adviser: "", // 置业顾问
      adviserDisabled: true,
      showPicker: false,
      showSuccess: false, // 推荐成功弹框
      tipsContent: "",
      isSuccess: true,
      disabled: true,
      cityValue: "",
      projectValue: {},
      adviserValue: {},

      oldName: "",
      idCard: "",
      oldPhone: "",
      presentee: "",
      gender: "0",
      contactNumber: "",
      orgCode: "",
      remark: "",
      projectName: "",
      adviserName: "",
      adviserCode: "",
      orgName: "",
      projectCode: "",
    };
  },
  created() {
    // this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');
    document.title = "老带新推荐";
    //app返回
    // this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');

    // this.$jsBridge.callHandler("dispatchBackBtn");
    // this.$jsBridge.registerhandler("onBackPressed", () => {
    //   this.goBack();
    // });
    //获取置业顾问信息
    this.$api.getOperatorInfo().then((res) => {
      this.adviserName = res.body.managerName;

      this.adviserCode = res.body.managerCode;
      this.projectCode = res.body.projectCode;
      this.projectName = res.body.projectName;
      this.orgCode = res.body.orgCode;
      this.orgName = res.body.orgName;
    });
  },
  methods: {
    userName(val) {
      if (val.length > 20 || val.length < 2) {
        return false;
      }
      return true;
    },
    //返回列表页
    goBack() {
      this.$router.go(-1);
    },
    // 提交推荐信息
    onSubmit(e) {
      let params = {
        recUserIdCard: this.idCard,
        recUserPhone: this.oldPhone,
        recommend: {
          recUsername: this.oldName,
          presentee: this.presentee,
          gender: this.gender,
          contactNumber: this.contactNumber,
          orgCode: this.orgCode,
          remark: this.remark,
          projectName: this.projectName,
          adviserName: this.adviserName,
          adviserCode: this.adviserCode,
          orgName: this.orgName,
          projectCode: this.projectCode,
          ifOldbeitnewRecommend: 2,
          recUserMobile: this.oldPhone,
        },
      };
      if (this.flag == true) {
        this.flag = false;
        this.timerFlag = setTimeout(() => {
          this.flag = true;
        }, 1000);
        this.loadingStatus = true;
        this.$api
          .saveOaN(params)
          .then((res) => {
            this.flag = true;
            clearTimeout(this.timerFlag);
            if (res.code === "0000") {
              this.showSuccess = true;
              this.isSuccess = true;
              this.tipsContent = "";
            } else if (res.code === "0007") {
              this.isSuccess = false;
              this.showSuccess = true;
              this.tipsContent = "请勿重复推荐";
            } else {
              this.showSuccess = true;
              this.isSuccess = false;
              this.tipsContent = (res.body && res.body.message) || res.message;
            }
            this.loadingStatus = false;
          })
          .catch((res) => {
            this.loadingStatus = false;
            this.isSuccess = false;
            this.showSuccess = true;
            this.tipsContent = (res.data && res.data.message) || res;
          });
      }
    },
    selectCity(e) {
      this.cityValue = e.value;
      this.disabled = false;
      this.projectValue = {};
      this.adviserValue = {};
      this.getProjList(e.value);
      this.projectValue = {};
      this.adviserValue = {};
    },
    // 选择项目
    selectProject(e) {
      this.projectValue = e.value;
      this.adviserDisabled = false;
      this.adviserValue = {};
      this.getAdviserList(e.value.projectCode);
      this.adviserValue = {};
    },
    // 选择置业顾问
    selectAdviser(e) {
      this.adviserValue = e.value;
    },
    // 提交成功后返回首页
    back() {
      if (!this.isSuccess) {
        this.showSuccess = false;
      } else {
        this.$router.go(-1);
        clearTimeout(this.timer);
      }
    },
    // 获取城市列表
    getCityList() {
      this.$api.getCityList({ type: "wx" }).then((res) => {
        if (res.code === "0000") {
          this.cityList = res.body;
        }
      });
    },
    // 获取项目列表
    getProjList(orgName) {
      this.$api.getProjList({ orgName, type: "wx" }).then((res) => {
        if (res.code === "0000") {
          this.projList = res.body;
        }
      });
    },
    // 获取置业顾问列表
    getAdviserList(projCode) {
      this.$api.getAdviser({ projectCode: projCode }).then((res) => {
        if (res.code === "0000") {
          this.adviserList = res.body.concat([
            {
              id: "",
              managerName: "自动分配",
              managerCode: "",
            },
          ]);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.take_to {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .bg {
    width: 100%;
    height: 248px;
    background-image: url("../../common/images/recommend/info_bg.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    .tips {
      color: #fff;
      font-size: 28px;
      margin-top: 38px;
    }
  }
  .main {
    flex: 1;
    width: 690px;
    position: relative;
    .table {
      width: 690px;
      height: 900px;
      padding-top: 16px;
      box-sizing: border-box;
      // background: #f7f7f7;
      background: #fff;
      position: absolute;
      top: -150px;
      border-radius: 16px;
      .old_info {
        padding: 20px 0;
        .head {
          padding: 0px 20px;
          display: flex;
          margin-bottom: 10px;
          span {
            font-size: 32px;
            margin-right: 16px;
            font-weight: 500;
            color: #333333;
            &:nth-child(1) {
              width: 6px;
              height: 32px;
              background: #0d9869;
              border-radius: 4px;
            }
          }
        }
      }
      .line {
        height: 1px;
        background: #ebedf0;
        margin: {
          left: 30px;
          right: 30px;
        }
      }
      .sex_icon {
        width: 32px;
        height: 38px;
      }
    }
    .btn {
      padding: {
        left: 16px;
        right: 16px;
      }
      margin-top: 50px;
      margin-bottom: 50px;
      font-size: 32px;
    }
    .text_tips {
      width: 100%;
      height: 200px;
      padding: 32px;
      box-sizing: border-box;
      color: rgba(169, 169, 169, 0.7);
      font-size: 28px;
      margin-bottom: 100px;
      p {
        margin-top: 10px;
        text-indent: 1em;
      }
    }
  }
  .tip_success {
    width: 540px;
    height: 730px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      color: #333333;
      .success_icon {
        width: 374px;
        height: 372px;
        margin-bottom: 38px;
      }
      .status {
        font-size: 52px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 74px;
        text-align: center;
      }
      p {
        // width: 264px;
        // height: 68px;
        padding: 0 40px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 34px;
        text-align: center;
      }
    }
    .success_btn {
      width: 452px;
      height: 76px;
      background: #0d9869;
      color: #fff;
      font-size: 28px;
      text-align: center;
      line-height: 76px;
      border-radius: 50px;
    }
  }
}
</style>
<style lang="scss">
.take_to {
  .van-form {
    position: relative;
  }
  .must {
    .van-field--error .van-field__control,
    .van-field--error .van-field__control::placeholder {
      color: rgba(150, 151, 153, 0.5);
    }
    .van-cell {
      height: 102px;
      align-items: center;
    }
    .van-field--disabled {
      color: #666666;
    }
    .van-field__label {
      color: #666666;
    }
    .van-field__control:disabled {
      color: #666666;
    }
    // .van-field__label span::after {
    //   content: '*';
    //   color: red;
    //   margin-left: 5px;
    // }
    // .adviser {
    //   .van-field__label span::after {
    //     content: '';
    //     color: red;
    //     margin-left: 5px;
    //   }
    // }
  }
  .no-must {
    .van-cell {
      padding: 16px;
      display: block;
    }
    .van-field__label {
      width: auto;
    }
    .van-field__value {
      border: 0.5px solid #f2f2f2;
      border-radius: 8px;
      height: 198px;
      margin-top: 24px;
      padding: {
        top: 5px;
        left: 10px;
      }
      box-sizing: border-box;
    }
  }
  .btn {
    .van-button--info {
      background: #0d9869;
      border: none;
    }
  }
}
</style>
